import { Result } from 'antd';
import React from 'react';

const MaintenancePage: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Result
        status="info"
        title="Technical Work in Progress"
        subTitle={
          <>
            We're currently performing some maintenance work.
            <br />
            The site will be available soon. Thank you for your patience.
          </>
        }
        style={{
          background: 'white',
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          maxWidth: '500px'
        }}
      />
    </div>
  );
};

export default MaintenancePage;
